import { initializeApp } from "firebase/app"
import { getAuth, RecaptchaVerifier, connectAuthEmulator } from "firebase/auth";
import { GetLostFirebaseAuth } from "./getlostAuthProvider";
const isProduction = import.meta.env.VITE_ENV === "production";
const emulatorUrl = import.meta.env.VITE_FIREBASE_AUTH_EMULATOR_HOST;
// When running inside a Coder workspace, the SDK must target the same
// origin as the page so requests flow through the Vite proxy and skip
// Coder's auth edge (which 303-redirects preflights, rejected by the
// CORS spec). Locally we keep the env var so the loopback emulator
// still works.
const authEmulatorTarget =
  typeof window !== "undefined" && window.location.hostname.endsWith(".coder.app")
    ? window.location.origin
    : emulatorUrl;

const firebaseConfig = isProduction
  ? {
      apiKey: "AIzaSyAGcjji29xlMYt9gA-k3Iuj1ahyGceDIAc",
      authDomain: "getlost-me.firebaseapp.com",
      projectId: "getlost-me",
      storageBucket: "getlost-me.appspot.com",
      messagingSenderId: "405379156708",
      appId: "1:405379156708:web:2704822344527283a83af1",
      measurementId: "G-QPE2RJF90B",
    }
  : {
      apiKey: "AIzaSyAdlavXPrJsmmNimKwJGNdj11CHuUDlzIY",
      authDomain: "getlostworlddev.firebaseapp.com",
      databaseURL: "https://getlostworlddev.firebaseio.com",
      projectId: "getlostworlddev",
      storageBucket: "getlostworlddev.appspot.com",
      messagingSenderId: "141036054368",
      appId: "1:141036054368:web:a8e50af2a14ebc347ae005",
      measurementId: "G-8FNEWXJ816",
    };

export const firebaseApp = initializeApp(firebaseConfig);
export const getlostFirebaseAuth = new GetLostFirebaseAuth(undefined, firebaseApp, getAuth(firebaseApp));

// ponytail: connect to Auth Emulator in dev when VITE_FIREBASE_AUTH_EMULATOR is set
if (emulatorUrl) {
  connectAuthEmulator(getAuth(firebaseApp), authEmulatorTarget);
}

let recaptchaInstance: RecaptchaVerifier | null = null;

/**
 * Initialize or return a singleton invisible reCAPTCHA verifier.
 * Caller must ensure a container element exists with the provided ID.
 */
export function getInvisibleRecaptcha(containerId: string): RecaptchaVerifier {
  if (recaptchaInstance) {
    return recaptchaInstance;
  }
  const auth = getAuth(firebaseApp);
  recaptchaInstance = new RecaptchaVerifier(auth, containerId, {
    size: "invisible",
  });
  return recaptchaInstance;
}
